import React,{ PureComponent } from 'react';
import Lang from "@/components/Lang/Lang";
import {message, Select,} from 'antd';
import PropTypes from 'prop-types';
import './index.less';
import WarehouseSelectService from "./WarehouseSelect.action";
const { Option } = Select;

/**
 * 仓库选择组件
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 *
 **/
class WarehouseSelect extends PureComponent{
    static propTypes = {
        onChange: PropTypes.func,
    }
    static defaultProps = {
        title:'',
    };
    constructor(props){
        super(props)
        this.state = {
            loading: false,
            warehouseList:[],//仓库列表
            valueList :props.value || ["all"],//选择值数组
        }
    }
    tagRender = (CustomTagProps={}) => {
        const { label, } = CustomTagProps;
        const onPreventMouseDown = (event) => {
            event.preventDefault();
            event.stopPropagation();
        };
        if(label){
            const text = label.length>0&&label[0].props?label[0].props.children:(label.props?label.props.children:"");
            return (<span style={{ marginRight: 3 }} onMouseDown={onPreventMouseDown}>
                <i className="ri-building-line mr_4"></i>
                {text}
            </span> );
        }else return
    };
    renderOption=(warehouseList=[])=>{
        let list = [];
        list.push(<Option value={"all"} key={"all"}>
            <p>
                {Lang({id:'SuoYouCangKu',default:'所有仓库'})}
            </p>
        </Option>)
        warehouseList.forEach(item=>{
            const iconUrl =item.abbreviate?require('../../assets/img/country/'+item.abbreviate + '.png'):"";
            list.push(<Option key={item.transitCityId} value={item.transitCityId} label={item.transitCityName}>
                <p title={item.transitCityName}>
                    {item.transitCityName}
                </p>
                <div className={"flex-item-ver-center font_12 black45"}>
                    {iconUrl?<img src={iconUrl.default} height={10.5} className={"mr_8"} />:null}
                    {item.countryName}
                </div>
            </Option>)
        })
        return list
    }
    handleChange(value,optionValue){
        if(value.length>1){//如果多选超过1项即可能出现选中全选
            value = value.filter(item=>item!=='all')
        }
        this.setState({
            valueList :value
        })
        if(this.props.onChange)this.props.onChange(value)//回调传参
    }
    handleSelect(value,optionValue){
        if(value=='all'){
            this.setState({
                valueList :[value]
            })
            if(this.props.onChange)this.props.onChange("");// 所有仓库 []  不用传参筛选
        }
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    /**
     * 搜索
     * @param pageIndex 页码
     * @param fetchCondition 条件
     */
    fetch(){
        this.loading(true);
        WarehouseSelectService.fetch().then((resp)=>this.handleRes(resp.data)).catch(err=>this.handleRes(err));
    }
    handleRes(res={}){
        this.loading(false);
        const {success,valid,models,paging} = res;
        if (success && valid) {
            this.setState({
                warehouseList: models
            })
        }
    }
    // 筛选
    filterOption(type,inputValue,option={}){
        if(inputValue&&option.label){
            if(option.label.indexOf(inputValue)>=0) return option
        }
    }
    /**
     * 进入 加载数据 列表
     */
    componentDidMount() {
        this.fetch();
        if(this.props.onRef)this.props.onRef(this);
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const { valueList,warehouseList } = this.state;
        return (<Select popupClassName={"warehouse-select-popup"}
                        mode="multiple"
                        showArrow
                        maxTagCount={1}
                        placeholder={Lang({id:'SuoYouCangKu',default:'所有仓库'})}
                        // dropdownMatchSelectWidth={false}
                        tagRender={this.tagRender}
                        onChange={(value,optionValue)=>this.handleChange(value,optionValue)}
                        onSelect={(value,optionValue)=>this.handleSelect(value,optionValue)}
                        optionFilterProp={(str)=>this.filterOption('optionFilterProp',str)}
                        filterOption={(inputValue,option)=>this.filterOption('filterOption',inputValue,option)}
                        value={valueList}
                        style={{minWidth: '182px',maxWidth: '400px' }}
                    >
                {this.renderOption(warehouseList)}
            </Select>)
    }
}
export default WarehouseSelect;
